var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 112,
    viewBox: "0 0 88 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_158_2448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8085 33.117H57.1915C57.6711 33.117 58.1311 32.9265 58.4703 32.5873C58.8095 32.2482 59 31.7882 59 31.3085C59 30.8289 58.8095 30.3689 58.4703 30.0297C58.1311 29.6905 57.6711 29.5 57.1915 29.5H30.8085C30.3289 29.5 29.8689 29.6905 29.5297 30.0297C29.1905 30.3689 29 30.8289 29 31.3085C29 31.7882 29.1905 32.2482 29.5297 32.5873C29.8689 32.9265 30.3289 33.117 30.8085 33.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1915 47.9399H30.8085C30.3289 47.9399 29.8689 48.1305 29.5297 48.4696C29.1905 48.8088 29 49.2688 29 49.7485C29 50.2281 29.1905 50.6881 29.5297 51.0273C29.8689 51.3664 30.3289 51.557 30.8085 51.557H57.1915C57.429 51.557 57.6642 51.5102 57.8836 51.4193C58.103 51.3284 58.3024 51.1952 58.4703 51.0273C58.6382 50.8593 58.7715 50.66 58.8623 50.4405C58.9532 50.2211 59 49.986 59 49.7485C59 49.511 58.9532 49.2758 58.8623 49.0564C58.7715 48.8369 58.6382 48.6376 58.4703 48.4696C58.3024 48.3017 58.103 48.1685 57.8836 48.0776C57.6642 47.9867 57.429 47.9399 57.1915 47.9399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1915 38.7196H30.8085C30.3289 38.7196 29.8689 38.9102 29.5297 39.2493C29.1905 39.5885 29 40.0485 29 40.5281C29 41.0078 29.1905 41.4678 29.5297 41.807C29.8689 42.1461 30.3289 42.3367 30.8085 42.3367H57.1915C57.6711 42.3367 58.1311 42.1461 58.4703 41.807C58.8095 41.4678 59 41.0078 59 40.5281C59 40.0485 58.8095 39.5885 58.4703 39.2493C58.1311 38.9102 57.6711 38.7196 57.1915 38.7196Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3438 99H24.251V93.1465C24.251 91.8984 25.0947 90.9844 26.2725 90.9844C27.3887 90.9844 28.1006 91.6875 28.1006 92.7949V99H29.9727V93.0762C29.9727 91.8545 30.7988 90.9844 31.9678 90.9844C33.1543 90.9844 33.8311 91.7051 33.8311 92.9531V99H35.7295V92.4961C35.7295 90.5889 34.499 89.3496 32.6182 89.3496C31.2559 89.3496 30.1309 90.0527 29.6299 91.2041H29.5859C29.1992 90.0176 28.2412 89.3496 26.9141 89.3496C25.666 89.3496 24.6377 90 24.1982 91.0723H24.1631V89.4551H22.3438V99ZM41.6094 90.8877C42.998 90.8877 43.9385 91.8721 43.9824 93.3574H39.1396C39.2451 91.8896 40.2383 90.8877 41.6094 90.8877ZM43.9736 96.2051C43.71 97.04 42.8398 97.5674 41.7324 97.5674C40.168 97.5674 39.1309 96.4775 39.1309 94.8252V94.7109H45.8896V94.043C45.8896 91.1514 44.2373 89.332 41.6182 89.332C38.9463 89.332 37.2061 91.2744 37.2061 94.2627C37.2061 97.251 38.9287 99.1143 41.6973 99.1143C43.8418 99.1143 45.5205 97.9189 45.793 96.2051H43.9736ZM47.4277 99H49.335V93.4893C49.335 91.9863 50.1963 90.9844 51.6377 90.9844C53.0352 90.9844 53.7031 91.793 53.7031 93.2432V99H55.6104V92.8828C55.6104 90.6855 54.4062 89.3496 52.2969 89.3496C50.8203 89.3496 49.8623 89.9385 49.2822 91.0635H49.2471V89.4551H47.4277V99ZM65.6562 89.4551H63.749V94.957C63.749 96.4688 62.8789 97.4619 61.4551 97.4619C60.0752 97.4619 59.3809 96.6797 59.3809 95.2119V89.4551H57.4736V95.5723C57.4736 97.7607 58.7393 99.1055 60.8223 99.1055C62.2812 99.1055 63.248 98.499 63.8018 97.3652H63.8369V99H65.6562V89.4551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_158_2448",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_2448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_2448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_2448",
    x: 14.3438,
    y: 85.332,
    width: 59.3125,
    height: 25.7822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_2448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_2448",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbButton);
export default __webpack_public_path__ + "static/media/thumb-button.85639a32ba9b484575f10b676cc23dbf.svg";
export { ForwardRef as ReactComponent };